import { rejected, resolved } from '../../createAction';
import { GET_ROOT_FOLDER } from './types';

const initialState = {
  root: null,
}

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case resolved(GET_ROOT_FOLDER):
      return {
        ...state,
        root: payload
      }
    default:
      return state;
  }
}
